var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 617,
    height: 487,
    viewBox: "0 0 617 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.281 203.323H152.376C150.541 203.323 149.053 204.811 149.053 206.647V206.647C149.053 208.482 150.541 209.97 152.376 209.97H195.281V203.323Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.68 206.601H70.3865C63.9822 206.376 51.1735 200.266 51.1735 177.623V31.3861C51.4937 21.2776 48.0994 1.06055 31.9604 1.06055C15.8215 1.06055 5.06216 1.06055 1.69988 1.06055",
    stroke: "#F39B2D",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.43 282.14H152.377C150.542 282.14 149.054 280.652 149.054 278.816V278.816C149.054 276.981 150.542 275.493 152.377 275.493H191.43V282.14Z",
    fill: "#326CE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.43 278.877H70.7372C64.3002 279.103 51.4262 285.241 51.4262 307.987V454.888C51.748 465.043 48.3364 485.352 32.1152 485.352C15.8939 485.352 5.0797 485.352 1.70027 485.352",
    stroke: "#326CE5",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.43 240.357H142.746C140.911 240.357 139.423 241.845 139.423 243.681V243.681C139.423 245.517 140.911 247.005 142.746 247.005H191.43V240.357Z",
    fill: "#59C7AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.994 243.206H1.70044",
    stroke: "#59C7AE",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M425.461 203.232H464.467C466.328 203.232 467.837 204.741 467.837 206.602C467.837 208.463 466.328 209.971 464.467 209.971H425.461V203.232Z",
    fill: "#2F69DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M468.211 206.602H546.504C552.909 206.377 565.717 200.267 565.717 177.624V31.3871C565.397 21.2786 568.791 1.06152 584.93 1.06152C601.069 1.06152 611.829 1.06152 615.191 1.06152",
    stroke: "#326CE5",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M425.461 282.231H464.684C466.545 282.231 468.053 280.723 468.053 278.862C468.053 277.001 466.545 275.492 464.684 275.492H425.461V282.231Z",
    fill: "#F39B2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M467.461 278.862H546.154C552.591 279.087 565.465 285.197 565.465 307.84V454.077C565.143 464.185 568.554 484.402 584.776 484.402C600.997 484.402 611.811 484.402 615.191 484.402",
    stroke: "#F39B2D",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M433.166 240.357H473.78C475.615 240.357 477.103 241.845 477.103 243.681C477.103 245.517 475.615 247.005 473.78 247.005H433.166V240.357Z",
    fill: "#59C7AE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M470.896 243.206H615.191",
    stroke: "#59C7AE",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureLines);
export default __webpack_public_path__ + "static/media/feature-lines.dd4fe58744bebda3829f5fd5e4cecc4c.svg";
export { ForwardRef as ReactComponent };